import React from 'react';
import { Button, Card, CardGroup } from '@ver-uds/uswds-react';
import { EveRoutes } from '@ver-uds/e-verify';
import newEvePlusLogoImage from '../../../images/newEvePlusLogo.svg';
import './HomeEVerifyPlusBanner.scss';
import ExternalLinks from '../../../constants/ExternalLinks';

const HomeEVerifyPlusBanner = (): JSX.Element => {
  return (
    <CardGroup className="margin-top-3 margin-bottom-neg-3">
      <Card flag className="home-everify-plus-banner width-full">
        <Card.Media className="display-block margin-top-4 margin-left-8 margin-right-8">
          <img width="50%" src={newEvePlusLogoImage} alt="Opt-in to E-Verify+ or Enable E-Verify+ banner" />
        </Card.Media>
        <Card.Header headerClassName="margin-top-2" as="h2">
          Modernize the employment eligibility verification process today!
        </Card.Header>
        <Card.Footer className="margin-top-2">
          <a
            target="_blank"
            className="usa-button usa-button--outline"
            href={`${ExternalLinks.E_VERIFY_PLUS}`}
            rel="noopener noreferrer"
            aria-label="Click here to learn more about E-Verify+ in a new tab"
          >
            Learn More
          </a>
          <Button
            variant="primary"
            as="a"
            href={EveRoutes.EVERIFY_PLUS_TOS}
            aria-label="Click here to open the E-Verify+ Terms of Service page in the current tab"
          >
            Enable E-Verify+
          </Button>
        </Card.Footer>
      </Card>
    </CardGroup>
  );
};

export default HomeEVerifyPlusBanner;
